var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.573,
    height: 73.2,
    viewBox: "0 0 71.573 73.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x38_59-Interface_x2C__Tick_x2C__User",
    transform: "translate(-31.93 -25.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(31.93 25.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6053",
    "data-name": "Path 6053",
    d: "M453.557,115.5a1.627,1.627,0,1,1-1.627,1.627A1.627,1.627,0,0,1,453.557,115.5Z",
    transform: "translate(-383.61 -100.86)",
    fill: "#72b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6054",
    "data-name": "Path 6054",
    d: "M453.557,375.5a1.627,1.627,0,1,1-1.627,1.627A1.627,1.627,0,0,1,453.557,375.5Z",
    transform: "translate(-383.61 -318.567)",
    fill: "#72b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6055",
    "data-name": "Path 6055",
    d: "M395.183,435.5a3.253,3.253,0,1,1-3.253,3.253A3.252,3.252,0,0,1,395.183,435.5Z",
    transform: "translate(-333.37 -368.807)",
    fill: "#0054a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6056",
    "data-name": "Path 6056",
    d: "M383.557,25.5a1.627,1.627,0,1,1-1.627,1.627A1.627,1.627,0,0,1,383.557,25.5Z",
    transform: "translate(-324.997 -25.5)",
    fill: "#72b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6057",
    "data-name": "Path 6057",
    d: "M84.463,55.5A32.533,32.533,0,1,0,117,88.033,32.533,32.533,0,0,0,84.463,55.5Z",
    transform: "translate(-48.677 -50.62)",
    fill: "rgba(230,60,59,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6058",
    "data-name": "Path 6058",
    d: "M126.33,154.3a24.4,24.4,0,1,1,24.4-24.4A24.4,24.4,0,0,1,126.33,154.3Z",
    transform: "translate(-90.543 -92.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_47",
    "data-name": "Union 47",
    d: "M9777.14-16415.746l-5.749,5.75-4.6-4.6,5.75-5.752-5.75-5.748,4.6-4.6,5.751,5.75,5.754-5.756,4.6,4.6-5.752,5.752,5.752,5.752-4.6,4.6Z",
    transform: "translate(-9741.353 16457.762)",
    fill: "#e63c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6060",
    "data-name": "Path 6060",
    d: "M93.557,455.5a1.627,1.627,0,1,1-1.627,1.627A1.627,1.627,0,0,1,93.557,455.5Z",
    transform: "translate(-82.17 -385.553)",
    fill: "#72b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6061",
    "data-name": "Path 6061",
    d: "M56,45.5a4.067,4.067,0,1,1-4.067,4.067A4.066,4.066,0,0,1,56,45.5Z",
    transform: "translate(-48.677 -42.247)",
    fill: "#0054a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6062",
    "data-name": "Path 6062",
    d: "M33.557,125.5a1.627,1.627,0,1,1-1.627,1.627A1.627,1.627,0,0,1,33.557,125.5Z",
    transform: "translate(-31.93 -109.233)",
    fill: "#72b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M33.557,375.5a1.627,1.627,0,1,1-1.627,1.627A1.627,1.627,0,0,1,33.557,375.5Z",
    transform: "translate(-31.93 -318.567)",
    fill: "#72b9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(16.267 13.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6064",
    "data-name": "Path 6064",
    d: "M263.077,247.127a1.627,1.627,0,1,0-3.253,0,16.285,16.285,0,0,1-16.267,16.267,1.627,1.627,0,0,0-1.627,1.627v6.451c.538.035,1.08.055,1.627.055s1.089-.02,1.627-.055v-4.892A19.547,19.547,0,0,0,263.077,247.127Z",
    transform: "translate(-224.037 -222.727)",
    fill: "rgba(114,185,255,0.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M131.93,129.9a1.627,1.627,0,1,0,3.253,0,16.285,16.285,0,0,1,16.267-16.267,1.627,1.627,0,0,0,1.627-1.627v-6.451c-.538-.035-1.08-.055-1.627-.055s-1.089.02-1.627.055v4.892A19.547,19.547,0,0,0,131.93,129.9Z",
    transform: "translate(-131.93 -105.5)",
    fill: "rgba(114,185,255,0.69)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.34a25fb9490e618f800c677f5e84b007.svg";
export { ForwardRef as ReactComponent };